import { createMultistepForm } from "@app/state/form/multistep";
import { createToast } from "@/modules/toast-message"
import { toFormData } from "@app/helpers/formData";
import { maybeCastValueToString } from "@app/helpers/cast";
import urlProcessor, { getDefaultRedirect } from "@app/helpers/urlProcessor";
import { fields } from "./form/fields";
import { stages } from "./form/stages";
import { getValidFields } from "./helpers/watches/details/watchMembershipTypeDetails";
import { ref } from "vue";

/**
 * Creates the state object for the form
 * 
 * @returns {Object}
 */
export function createForm(){

    const additionalMembership = ref(false)

    return {
        ...createMultistepForm(
            stages, 
            fields, 
            'bt_create_membership',
            {
                responseKey : 'membership',
                callbacks   : {
                    onSuccess: [
                        (data) => {
                            if(data.code === 302){
                                window.location.href = data.redirect
                            } else {
                                createToast(data.message ?? 'Membership processed successfully', "success")
    
                                if(data.data.id){
                                    window.location.href = urlProcessor(
                                        additionalMembership.value
                                            ? getDefaultRedirect('membership')
                                            : window.location.href, 
                                        { key: null, success: 1, membership: data.data.id }
                                    )
                                }
                            }
                        }
                    ],
                    onError: [
                        (data) => {
                            if(data.code === 422){
                                createToast("Please check entered data is valid", "error")
                            } else {
                                createToast("An error occured processing your request, please try again", "error")
                            }
                        } 
                    ]
                }
            }
        ),
        additionalMembership: additionalMembership
    }
}

/**
 * Apply a callback to the form for when we submit to append the data we require
 * which isn't available from the form fields
 * 
 * @param {Object} form 
 * @param {Object} progression 
 * @param {Object} membership_type
 * @param {Object} answers
 */
export function applyFormSubmissionApiCallback(form, progression, membership_type, answers){
    form.actions.submit.api.beforeRequest.value = (data) => {
        return toFormData(
            {
                ...data,
                redirect          : form.additionalMembership.value
                    ? getDefaultRedirect('membership')
                    : urlProcessor(window.location.href, { key: null }), //Remove progress key from the url as this won't exist anymore
                saved_progression : progression.details.value.key,
                fields            : getValidFields(data.fields, membership_type.details.value.fields, answers.details.value)
            }, 
            maybeCastValueToString
        )
    }
}